/**
 * AuthBackground — fond de marque de la zone auth : deux halos indigo, un
 * grain de film et une vignette. Purement décoratif (`aria-hidden`), en couche
 * `-z-10` sous le contenu. Les couleurs passent par le token `--color-brand`
 * (via `bg-brand`) ; grain et vignette sont en styles inline (décor pur, hors
 * échelle de tokens) pour ne pas polluer les utilities.
 */

export function AuthBackground() {
  return (
    <div aria-hidden className="pointer-events-none absolute inset-0 -z-10 overflow-hidden">
      {/* Halos aurore indigo */}
      <div className="bg-brand/20 absolute -top-32 -left-32 size-[500px] rounded-full blur-[140px]" />
      <div className="bg-brand/15 absolute -right-32 -bottom-32 size-[420px] rounded-full blur-[120px]" />

      {/* Grain de film */}
      <div
        className="absolute inset-0 mix-blend-screen"
        style={{
          backgroundImage: "url('/assets/grain.svg')",
          backgroundSize: '220px 220px',
          opacity: 0.045,
        }}
      />

      {/* Vignette : assombrit les bords */}
      <div
        className="absolute inset-0"
        style={{
          background:
            'radial-gradient(ellipse 100% 82% at 50% 46%, transparent 42%, rgba(0, 0, 0, 0.34) 80%, rgba(0, 0, 0, 0.6) 100%)',
        }}
      />
    </div>
  );
}
